module.exports = __webpack_public_path__ + "img/only-email-form.31a8291.png";